/* 用户协议 */
<template>
    <div class="agreement-box">
        <!-- 头部 -->
        <headerTop :title="agreement.title">
        
        </headerTop>
        <!-- 内容 -->
        <div class="content" v-html="agreement.content">
        </div>
        <!-- 底部按钮 -->
        <div @click="$router.go(-1)">
            <footBottom title="知道了"></footBottom>
        </div>
    </div>
</template>

<script>
import headerTop from "@/components/common/headerTop.vue";
import footBottom from "@/components/common/footBottom.vue";
import commonApi from "@/api/commonApi";
export default {
    data() {
        return {
            agreement: {}
        };
    },
    components: {
        headerTop,
        footBottom
    },
    mounted() {
        commonApi.pagesInfo('tied_card').then(res => {
            this.agreement = res;
        });
    }
};
</script>

<style lang="less" scoped>
.agreement-box {
    
    padding-bottom: 54px;
    .content {
        padding: 20px 15px;
        font-size: 14px;
        color: #333333;
    }
}
</style>
